// Where PDF.js finds its worker and support files unless the embedder
// says otherwise.
//
// The production build (scripts/build.mjs) defines __CASSIS_PDF_ASSETS__
// as the fingerprinted file and directory names it wrote beside the
// reader module, so a build finds its own, matching assets relative to
// import.meta.url. Unbundled (tests, the dev server) the files come
// straight from the pdfjs-dist package.
/* global __CASSIS_PDF_BUNDLED__, __CASSIS_PDF_ASSETS__ */

function bundledAssets(names) {
  const assets = {};
  for (const [key, name] of Object.entries(names)) {
    assets[key] = new URL(name, import.meta.url).href;
  }
  return assets;
}

// The build defines __CASSIS_PDF_BUNDLED__ as true, so esbuild folds this
// condition and drops the development paths from the bundle.
export const defaultPdfAssets =
  typeof __CASSIS_PDF_BUNDLED__ !== "undefined" && __CASSIS_PDF_BUNDLED__
    ? bundledAssets(__CASSIS_PDF_ASSETS__)
    : {
        workerSrc: "/node_modules/pdfjs-dist/build/pdf.worker.min.mjs",
        cMapUrl: "/node_modules/pdfjs-dist/cmaps/",
        standardFontDataUrl: "/node_modules/pdfjs-dist/standard_fonts/",
        wasmUrl: "/node_modules/pdfjs-dist/wasm/",
        iccUrl: "/node_modules/pdfjs-dist/iccs/",
      };
